import { baseApi } from './baseApi';

export const doctorApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    doctorLogin: builder.mutation({
      query: (credentials) => ({
        url: '/doctor/login',
        method: 'POST',
        body: credentials,
      }),
    }),
    doctorLogout: builder.mutation({
      query: () => ({
        url: '/doctor/logout',
        method: 'POST',
      }),
    }),
    getDoctorDashboard: builder.query({
      query: () => '/doctor/dashboard',
      providesTags: ['Doctor'],
    }),
    getDoctorAccount: builder.query({
      query: () => '/doctor/account',
      providesTags: ['Doctor'],
    }),
    updateDoctorAccount: builder.mutation({
      query: (data) => {
        if (data instanceof FormData) {
          data.append('_method', 'PUT');
          return { url: '/doctor/update-account', method: 'POST', body: data };
        }
        return { url: '/doctor/update-account', method: 'POST', body: { ...data, _method: 'PUT' } };
      },
      invalidatesTags: ['Doctor'],
    }),
    getTickets: builder.query({
      query: () => '/doctor/tickets',
      providesTags: ['Ticket'],
    }),
    getNewTickets: builder.query({
      query: () => '/doctor/new-tickets',
      providesTags: ['Ticket'],
    }),
    getTicketChat: builder.query({
      query: (id) => `/doctor/ticket-chat/${id}`,
      providesTags: ['Ticket'],
    }),
    getChat: builder.query({
      query: (id) => `/doctor/get-chat/${id}`,
      providesTags: ['Ticket'],
    }),
    sendMessage: builder.mutation({
      query: ({ id, formData }) => ({
        url: `/doctor/send-message/${id}`,
        method: 'POST',
        body: formData,
      }),
      invalidatesTags: ['Ticket'],
    }),
    closeTicket: builder.mutation({
      query: (id) => ({
        url: `/doctor/close-ticket/${id}`,
        method: 'POST',
      }),
      invalidatesTags: ['Ticket'],
    }),
    readNotifications: builder.mutation({
      query: () => ({
        url: '/doctor/read-notifications',
        method: 'POST',
      }),
    }),
  }),
});

export const {
  useDoctorLoginMutation,
  useDoctorLogoutMutation,
  useGetDoctorDashboardQuery,
  useGetDoctorAccountQuery,
  useUpdateDoctorAccountMutation,
  useGetTicketsQuery,
  useGetNewTicketsQuery,
  useGetTicketChatQuery,
  useGetChatQuery,
  useSendMessageMutation,
  useCloseTicketMutation,
  useReadNotificationsMutation,
} = doctorApi;

